import {
  Box,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps
} from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import { useSize } from "@pathwright/ux/src/utils/size"
import React from "react"
import Pathicon from "../../pathicon/Pathicon"
import {
  NewCohort,
  NewResource,
  SelectedCohort,
  SelectedResource
} from "./state"

type Item = NewResource | NewCohort | SelectedResource | SelectedCohort

export function ItemInputImage({ image }: { image: string }) {
  return (
    <Image
      src={image}
      maxH="24px"
      borderRadius="md"
      fallback={<Box maxH="24px" bg="gray.200" borderRadius="md" />}
    />
  )
}

export const ItemNameInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ value, onChange, ...rest }, ref) => (
    <Input
      type="text"
      value={value}
      onChange={onChange}
      autoFocus
      borderRadius="xl"
      padding="0 .4em"
      _placeholder={{ fontSize: { base: "sm", md: undefined } }}
      ref={ref}
      {...rest}
    />
  )
)

function ItemInput({
  value,
  onChange,
  icon,
  ...inputProps
}: {
  value: Item
  onChange: (item: Item) => void
} & Omit<InputProps, "value" | "onChange"> & { icon?: IconName }) {
  const [leftElementRef, leftElementSize] = useSize("width")

  return (
    <InputGroup>
      <InputLeftElement
        ref={leftElementRef}
        pointerEvents="none"
        children={
          !!value && "image" in value ? (
            <ItemInputImage image={value.image} />
          ) : icon ? (
            <Pathicon
              icon={icon}
              color={
                inputProps.isDisabled ? "whiteAlpha.600 !important" : undefined
              }
            />
          ) : null
        }
        ml=".4em"
      />
      <ItemNameInput
        value={value?.name || ""}
        onChange={(e) => onChange({ ...value, name: e.target.value })}
        paddingLeft={
          leftElementSize
            ? `calc(${leftElementSize}px + .4em)`
            : "var(--input-height)"
        }
        {...inputProps}
      />
    </InputGroup>
  )
}

export default ItemInput
